// src/components/JsonLd.js
// Injects a <script type="application/ld+json"> tag.
import React from 'react';

export default function JsonLd({ data }) {
  if (!data) return null

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(data, null, process.env.NODE_ENV === 'development' ? 2 : 0),
      }}
    />
  )
}
